import { css } from '@emotion/css';
import { Spacing } from '@snapchat/snap-design-system';

export const usersSectionClassName = css({
  paddingTop: Spacing.MD,
});
